import FormSelectField from '../../../formFields/FormSelectField';
import { ppeOptions } from './safetyPlanOptions';

const SafetyPlanPpeSection = () => {
  return (
    <div className="mb-3">
      <FormSelectField
        title="Required Personal Protective Equipment (PPE)"
        fieldName="requiredPpe"
        placeholder="Click to select PPE..."
        options={ppeOptions.map((ppe) => ({ label: ppe, value: ppe }))}
        isMulti={true}
        isClearable={true}
        variant="full"
      />
    </div>
  );
};

export default SafetyPlanPpeSection;
